{
  "countryCode": "رمز الدولة",
  "choosePlaceholder": "اختر الدولة",
  "countrySearch": "ابحث عن دولة بالاسم أو الرمز",
  "noCountry": "لا توجد دولة مطابقة",
  "helper": "أدخل رقم خلوي",
  "errors": {
    "PHONE_REQUIRED": "رقم الهاتف مطلوب",
    "PHONE_INVALID": "رقم الهاتف غير صالح",
    "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
    "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة"
  }
}
